import { IReinstateablePolicy } from "config";
import { gql } from "config/graphql";
import { getApolloClient } from "store/apollo";
import { assertDefined } from "utils/error";

import type { MutationResponse, ProductDetailSlug, SuccessResponse } from "config/types";

export interface ICoverageAdjustmentInput {
  policyId: string;
  amount: number;
}

interface IRequestCoverageAdjustmentData {
  requestCoverageAdjustment: SuccessResponse<{ status: string }>;
}

export const requestCoverageAdjustment: MutationResponse<
  ICoverageAdjustmentInput,
  IRequestCoverageAdjustmentData
> = async (adjustment: ICoverageAdjustmentInput) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation RequestCoverageAdjustment($input: RequestCoverageAdjustmentInput!) {
      requestCoverageAdjustment(input: $input) {
        response {
          success
          status
        }
      }
    }
  `;

  const { data } = await client.mutate<IRequestCoverageAdjustmentData>({
    variables: {
      input: adjustment,
    },
    mutation,
  });
  return { data: assertDefined(data) };
};

interface IRequestReinstatementData {
  requestReinstatement: SuccessResponse<{ status: string }>;
}

export const requestReinstatement = async (policyId: IReinstateablePolicy["id"]) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation requestReinstatement($input: RequestReinstatementInput!) {
      requestReinstatement(input: $input) {
        response {
          status
          success
        }
      }
    }
  `;

  const { data } = await client.mutate<IRequestReinstatementData>({
    mutation,
    variables: {
      input: {
        policyId,
      },
    },
  });
  return { data: assertDefined(data) };
};

export interface IRequestNewBusiness {
  product: ProductDetailSlug;
}

interface IRequestNewBusinessData {
  requestNewBusiness: SuccessResponse<{ status: string }>;
}

export const requestNewBusiness = async ({ product }: IRequestNewBusiness) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation requestNewBusiness($input: RequestNewBusinessInput!) {
      requestNewBusiness(input: $input) {
        response {
          status
          success
        }
      }
    }
  `;

  const { data } = await client.mutate<IRequestNewBusinessData>({
    mutation,
    variables: {
      input: {
        product,
      },
    },
  });
  return { data: assertDefined(data) };
};
